module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.5dd9189.ttf";